import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useGetEstimate, useGetEstimatesList } from '~/hooks/estimates';
import styles from './rental-form.module.scss';

import {
  StyledSelect,
} from '~/lib/HooksFormFields';
import PreviewField from '~/components/PreviewField';
import { IPhase } from '~/types/estimates';

const RentalForm = ({ isPreview } : { isPreview: boolean }) => {
  const { control } = useFormContext();
  const { id, phaseId } = useParams();
  const {
    data: estimate,
  } = useGetEstimate(id || '');

  const phase = useMemo(() => {
    const found = estimate?.phases.find((d: IPhase) => d._id === phaseId);
    return found;
  }, [estimate, phaseId]);

  const isUmbrella = phase?.type === 'umbrella';
  const locationDiscount = estimate?.location?.discount && estimate.location.discount > 0
    ? estimate.location.discount
    : 0;
  const globalPriceSuffix = estimate?.location?.globalPrice && estimate?.worksite?.duration
    ? ` (pour ${estimate.worksite.duration} mois)`
    : '';

  const { data: list = { rental: {} } } = useGetEstimatesList();
  const {
    durations,
  } = list.rental;

  return (
    <div id="location" className={styles.rental}>
      <h4>Location</h4>
      <div className={styles.row}>
        <div className={styles.containerField}>
          {isPreview
            ? <PreviewField
              label='Durée'
              value={phase?.rental?.duration ? `${phase.rental.duration} mois` : '---'}
            />
            : <StyledSelect
            label='Durée'
            name='rental.duration'
            control={control}
            options={durations}
          />
          }
        </div>
      </div>
      {(phase?.rental && Number(phase.rental.duration) > 0)
        && <>
        {isUmbrella && phase.rental.raisedUnitPrice != null && phase.rental.raisedUnitPrice > 0
          && <div className={styles.row}>
            <p className={`${styles.price} ${locationDiscount > 0 ? styles.discount : ''}`}>
              Prix unitaire parapluie{globalPriceSuffix} :
              <span>{phase.rental.raisedUnitPrice} €</span>
              {' '}{locationDiscount > 0 ? <span>{(phase.rental.raisedUnitPrice * (1 - locationDiscount)).toFixed(2)} €</span> : null}
            </p>
          </div>
        }
        {isUmbrella && phase.rental.unitPrice != null && phase.rental.unitPrice > 0
          && <div className={styles.row}>
            <p className={`${styles.price} ${locationDiscount > 0 ? styles.discount : ''}`}>
              Prix unitaire réhausse{globalPriceSuffix} : <span>{phase.rental.unitPrice} €</span>
              {' '}{locationDiscount > 0 ? <span>{(phase.rental.unitPrice * (1 - locationDiscount)).toFixed(2)} €</span> : null}
            </p>
          </div>
        }
        {!isUmbrella && phase.rental.unitPrice != null && phase.rental.unitPrice > 0
          && <div className={styles.row}>
            <p className={`${styles.price} ${locationDiscount > 0 ? styles.discount : ''}`}>
              Prix unitaire : <span>{phase.rental.unitPrice} €</span>
              {' '}{locationDiscount > 0 ? <span>{(phase.rental.unitPrice * (1 - locationDiscount)).toFixed(2)} €</span> : null}
            </p>
          </div>
        }
        {!isUmbrella && phase.rental.raisedUnitPrice != null && phase.rental.raisedUnitPrice > 0
          && <div className={styles.row}>
            <p className={`${styles.price} ${locationDiscount > 0 ? styles.discount : ''}`}>
              Prix unitaire réhausse{globalPriceSuffix} :
              <span>{phase.rental.raisedUnitPrice} €</span>
              {' '}{locationDiscount > 0 ? <span>{(phase.rental.raisedUnitPrice * (1 - locationDiscount)).toFixed(2)} €</span> : null}
            </p>
          </div>
        }
        </>
        }
    </div>
  );
};

export default RentalForm;
